import styled from "styled-components";

export const Home = styled.div``;

export const CardDisplayWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;
